import React, { useState, useEffect } from "react";
import axios from "axios";
import versityOne from "../../../asset/images/versity_img11.jpg";
import "./Carousel.css";

const Carousel = () => {
  const [date, setDate] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/get-date`
        );
        setDate(response.data);
      } catch (error) {
        console.error("Error fetching date data", error);
        setError(error);
      }
    };

    fetchData();
  }, []);

  if (error) {
    return <div>Error loading data!</div>;
  }

  if (!date) {
    return <div>Loading...</div>;
  }

  return (
    <div id="carouselExample" className="carousel slide" data-bs-ride="carousel">
      {/* Title */}
      <div className="carousel-title">
        <span className="text-background">
          National Conference on Computational Intelligence and Applications - DURJOY (NCCIA 2025)
        </span>
      </div>

      <div className="carousel-inner">
        <div className="carousel-item active">
          <img
            src={versityOne}
            className="d-block w-100"
            alt="Conference Background"
          />
          <div className="carousel-caption d-none d-md-block">
            <div className="deadlines-grid">
              <div className="deadline-item">
                <span>Paper Submission Deadline:</span>
                <strong className="text-info">{date.data[0].PaperSubmissionDeadline}</strong>
              </div>
              <div className="deadline-item">
                <span>Acceptance Notification:</span>
                <strong className="text-info">{date.data[0].AcceptanceNotification}</strong>
              </div>
              <div className="deadline-item">
                <span>Registration Deadline:</span>
                <strong className="text-info">{date.data[0].RegistrationDeadline}</strong>
              </div>
              <div className="deadline-item">
                <span>Conference Date:</span>
                <strong className="text-info">{date.data[0].CameraReadySubmission}</strong>
              </div>
            </div>
            
            <div className="venue-home-container mt-4">
              <div className="deadline-item">
                <span>Conference Venue:</span>
                <strong className="text-info d-block mt-1">
                  Jashore University of Science and Technology Campus, Bangladesh
                </strong>
              </div>
            </div>

            <div className="d-flex justify-content-center mt-4">
              <button
                type="button"
                className="homeBtn"
                onClick={() =>
                  window.open(
                    "https://drive.google.com/file/d/1tgdOzNNgK87WB7Ws7ZRv2lRs_JjPhWtJ/view",
                    "_blank"
                  )
                }
              >
                Call For Paper
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Carousel;